<template>
    <div class="bg-lightest col-sm-12 py-4 mt-4">
        <div class="options d-flex align-items-center">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12 mt-3">
                        <div class="row">
                            <div class="d-flex col-sm-2 pl-0">
                                <div class="d-flex w-100">
                                    <input class="bg-lighter w-100" type="text" v-model="getInvoicePageFilters.string" placeholder="Search invoice" @input="searchDebounced">
                                </div>
                            </div>

                            <div class="col-sm-8 row align-items-center">
                                <button class="btn blue" @click="search">Search</button>
                            </div>

                            <div class="col-sm-2">
                                <div class="d-flex justify-content-end">
                                    <export :exportOptions="exportOptions"></export>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="row">
                            <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                <seller-picker class="w-100" ref="sellerSelector" 
                                    :allowEmpty="true" 
                                    :showMyTeam="false"
                                    :hideOthers='true'
                                    :hideAllByChannel="true"
                                    :hideGetYourGuide='true'
                                    :hideViator='true'
                                    :inlcudeWidget="false"
                                    placeholder="All Sellers"
                                    @input="sellerChanged"
                                    @deselect="deselectSeller">
                                </seller-picker>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getInvoiceTypes">
                                <v-select 
                                    :options="treatedInvoiceTypes" 
                                    label="label" 
                                    placeholder="All Documents" 
                                    v-model="filterType" 
                                    @input="changeInvoiceType">
                                </v-select>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                <v-select 
                                    :options="treatedProductList" 
                                    label="name" 
                                    placeholder="All" 
                                    v-model="filterProduct" 
                                    @input="changeProductFilter">
                                </v-select>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getInvoiceTargetTypes">
                                <v-select 
                                    :options="treatedInvoiceTargets" 
                                    label="label" 
                                    placeholder="All" 
                                    v-model="filterTargetType" 
                                    @input="changeInvoiceTargetType">
                                </v-select>
                            </div>

                            <div class="col-md-2 row align-items-center">
                                <button class="ml-3 btn tertiary filters__btn-clear--full-height" @click="clearFilters">Clear</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex'

import extendedVSelect from '@/extends/vue-select'
import Export from '@/tools/ExportV2'
import SellerPicker from '@/tools/SellerPicker'

export default {
    data() {
        return {
            exportOptions: [
                {
                    label: 'Excel',
                    action: this.getExcel
                }
            ],
            filterProduct: {
                id: null,
                name:'All Products'
            },
            filterType: {
                id: null,
                label: "All Documents"
            },
            filterTargetType: {
                id: null,
                label: "Billed to"
            }
        }
    },
    created() {
        this.clearInvoicePageFilters();
        this.requestDocumentTypes();
    },
    computed: {
        ...mapGetters([
            'getInvoicePageFilters',
            'getSlimFilters',
            'getAgents',
            'getInvoiceTargetTypes',
            'getInvoiceTypes',
        ]),
        treatedProductList() {
            let output = JSON.parse(JSON.stringify(this.getSlimFilters.productList));

            output.unshift({
                id:null,
                name:'All Products'
            })

            return output;
        },
        treatedInvoiceTypes() {
            let allTypes = JSON.parse(JSON.stringify(this.getInvoiceTypes));
            
            allTypes.unshift({
                id: null,
                label: "All Documents"
            });

            return allTypes;
        },
        treatedInvoiceTargets() {
            let allTargets = JSON.parse(JSON.stringify(this.getInvoiceTargetTypes));
            
            allTargets.unshift({
                id: null,
                label: "Billed to"
            });

            return allTargets;
        }
    },
    methods: {
        ...mapActions([
            'downloadInvoiceList',
            'exportInvoicePageExcel',
            'clearInvoicePageFilters',
            'requestDocumentTypes'
        ]),
        searchDebounced: _.debounce(function(){
                this.search();
            },
            500
        ),
        search(){
            this.downloadInvoiceList();
        },
        clearFilters() {
            this.seller = null;
            this.selectedSeller = null;
            
            this.filterType = {
                id: null,
                label: "All Documents"
            };
            
            this.filterProduct = {
                id:null,
                name:'All Products'
            };

            this.filterTargetType = {
                id: null,
                label: "Billed to"
            };

            if (this.$refs.sellerSelector) {
                this.$refs.sellerSelector.deselectSeller();
            }

            this.clearInvoicePageFilters();
            this.downloadInvoiceList();
        },
        getExcel() {
            this.exportInvoicePageExcel();
        },
        changeProductFilter() {
            if (this.filterProduct) {
                this.getInvoicePageFilters.productId = this.filterProduct.id;
            } else {
                this.getInvoicePageFilters.productId = null;
                this.filterProduct = {
                    id:null,
                    name:'All Products'
                }
            }

            this.search();
        },
        changeInvoiceType() {
            if (this.filterType) {
                this.getInvoicePageFilters.invoiceType = this.filterType.id;
            } else {
                this.getInvoicePageFilters.invoiceType = null;
                this.filterType = {
                    id: null,
                    label: "All documents"
                }
            }

            this.search();
        },
        changeInvoiceTargetType() {
            if (this.filterTargetType) {
                this.getInvoicePageFilters.targetType = this.filterTargetType.id;
            } else {
                this.getInvoicePageFilters.targetType = null;
                this.filterTargetType = {
                    id: null,
                    label: "Billed to"
                }
            }

            this.search();
        },
        sellerChanged(e) {
            // Resets before apply
            this.getInvoicePageFilters.onlyMyTeam = false;
            this.getInvoicePageFilters.agentId = null;
            this.getInvoicePageFilters.userId = null;
            this.getInvoicePageFilters.channelType = null;

            if (e.isAllMyTeam) {
                this.getInvoicePageFilters.channelType = 0;
            } else if (e.userAccountTypes) {
                this.getInvoicePageFilters.userId = e.id;
            } else if (e.channelType == 101) {
                // Sets filter for widget
                this.getInvoicePageFilters.channelType = 101;
               
                return true;
            } else {
                this.getInvoicePageFilters.userId = null;
                this.getInvoicePageFilters.agentId = e.id;
            }

            // Load invoices after changing filter
            this.search();
        },
        deselectSeller() {
            this.getInvoicePageFilters.userId = null;
            this.getInvoicePageFilters.agentId = null;
        }
    },
    components: {
        Export,
        vSelect: extendedVSelect,
        SellerPicker
    }
}
</script>

<style lang="scss" scoped>
    .filters__btn-clear {
        &--full-height {
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// Filters.vue?1112ddb6